import { BasePortfolio } from './../models/base-portfolio';
import { RiskAnalytics } from './../models/risk-analytics';
import { Security } from './../models/security';

export class ModelPortfolio extends BasePortfolio {
	private _baseModel: number;
	private _netExpenseRatio: number;
	private _portfolioId: number;
	private _yieldValue: number;
	private _holdingAsOfDate: string;
	private _yieldAsOfDate: number;
	private _netExpenseRatioAsOfDate: number;
	private _standardDeviation: number;
	private _standardDeviationAsOfDate: number;
	private _isAssetClassOnly: boolean;
	private _prevRebalancedDate: string;
	private _asOfDateType: string;

	constructor() {
		super();
	}

	public get securities(): Array<Security> {
		return this.children as Array<Security>;
	}

	public set securities(value: Array<Security>) {
		this.children = value;
	}

	public get asOfDateType(): string {
		return this._asOfDateType;
	}

	public set asOfDateType(value: string) {
		this._asOfDateType = value;
	}

	public get baseModel(): number {
		return this._baseModel;
	}

	public set baseModel(value: number) {
		this._baseModel = value;
	}

	public get netExpenseRatio(): number {
		return this._netExpenseRatio;
	}

	public set netExpenseRatio(value: number) {
		this._netExpenseRatio = value;
	}

	public get portfolioId(): number {
		return this._portfolioId;
	}

	public set portfolioId(value: number) {
		this._portfolioId = value;
	}

	public get yieldValue(): number {
		return this._yieldValue;
	}

	public set yieldValue(value: number) {
		this._yieldValue = value;
	}

	public get holdingAsOfDate(): string {
		return this._holdingAsOfDate;
	}

	public set holdingAsOfDate(value: string) {
		this._holdingAsOfDate = value;
	}

	public get yieldAsOfDate(): number {
		return this._yieldAsOfDate;
	}

	public set yieldAsOfDate(value: number) {
		this._yieldAsOfDate = value;
	}

	public get netExpenseRatioAsOfDate(): number {
		return this._netExpenseRatioAsOfDate;
	}

	public set netExpenseRatioAsOfDate(value: number) {
		this._netExpenseRatioAsOfDate = value;
	}

	public get standardDeviation(): number {
		return this._standardDeviation;
	}

	public set standardDeviation(value: number) {
		this._standardDeviation = value;
	}

	public get standardDeviationAsOfDate(): number {
		return this._standardDeviationAsOfDate;
	}

	public set standardDeviationAsOfDate(value: number) {
		this._standardDeviationAsOfDate = value;
	}

	public get isAssetClassOnly(): boolean {
		return this._isAssetClassOnly;
	}

	public set isAssetClassOnly(value: boolean) {
		this._isAssetClassOnly = value;
	}

	public get prevRebalancedDate(): string {
		return this._prevRebalancedDate;
	}

	public set prevRebalancedDate(value: string) {
		this._prevRebalancedDate = value;
	}

	public toString(): any {
		const securityGroupObj = {};
		Object.keys(this).forEach(property => {
			if (this[property] instanceof RiskAnalytics) {
				securityGroupObj[property] = this[property].toString();
			} else if (this[property] instanceof Date) {
				securityGroupObj[property] = this[property].getMonth() + 1 + '/' + this[property].getDate() + '/' + this[property].getFullYear();
			} else {
				securityGroupObj[property] = this[property];
			}
		});
		return securityGroupObj;
	}
}
